// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__zIjGo","consentsList":"PatientConsents_consentsList__PY82E","consentsListEmpty":"PatientConsents_consentsListEmpty__2-Ls6"};